import { render } from "./10_religiosa.vue?vue&type=template&id=21108261&scoped=true"
import script from "./10_religiosa.vue?vue&type=script&lang=js"
export * from "./10_religiosa.vue?vue&type=script&lang=js"

import "./10_religiosa.vue?vue&type=style&index=0&id=21108261&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21108261"]])

export default __exports__